import { useQuery } from '@tanstack/react-query';

import { teamApi } from '../api/team-api';

import { teamKeys } from './team-keys';

/** Read when the sheet opens; under the members key, so every member change refetches it. */
export function useEffectivePermissions(id: string | null) {
  return useQuery({
    queryKey: teamKeys.effective(id ?? ''),
    queryFn: () => teamApi.effectivePermissions(id ?? ''),
    enabled: id !== null,
  });
}
